var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallDrawerOpener(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 100,
    viewBox: "0 0 30 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 0C24.8954 0 24 0.895429 24 2V26H4C1.79086 26 0 27.7909 0 30V70C0 72.2091 1.79086 74 4 74H24V98C24 99.1046 24.8954 100 26 100H30V0H26Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3538 44.3664C14.549 44.5617 14.549 44.8783 14.3538 45.0735L10.0071 49.4202C9.68904 49.7383 9.68904 50.2617 10.0071 50.5798L14.3538 54.9264C14.549 55.1217 14.549 55.4383 14.3538 55.6335C14.1585 55.8288 13.8419 55.8288 13.6467 55.6335L9.3 51.2869C8.59141 50.5783 8.59141 49.4217 9.3 48.7131L13.6467 44.3664C13.8419 44.1712 14.1585 44.1712 14.3538 44.3664Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDrawerOpener);
export default __webpack_public_path__ + "static/media/small-drawer-opener.dd595e3f2f84e17b234294002f1a90d3.svg";
export { ForwardRef as ReactComponent };